import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function FooterCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-slate-900 text-white py-20" data-id="element-85">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-86">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-6" data-id="element-87">
          🤸 GIMNASIA ARTÍSTICA 360
        </h2>
        <p className="text-xl text-blue-300 mb-8 font-medium" data-id="element-88">
          El sistema de planificación N°1 para profesores de gimnasia artística
          argentinos.
        </p>

        <p className="text-2xl font-bold italic text-white mb-12" data-id="element-89">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <button onClick={scrollToPricing} className="w-full md:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-bold text-xl py-5 px-12 rounded-full shadow-[0_0_40px_rgba(37,99,235,0.3)] hover:shadow-[0_0_60px_rgba(37,99,235,0.5)] transition-all duration-300 transform hover:-translate-y-1 mb-10" data-id="element-90">
          💪 QUIERO MI GIMNASIA 360 AHORA
        </button>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400 mb-16" data-id="element-91">
          <div className="flex items-center gap-2" data-id="element-92">
            <Shield className="w-4 h-4" data-id="element-93" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-94">
            <Lock className="w-4 h-4" data-id="element-95" /> Pago seguro · Acceso inmediato
          </div>
          <div className="flex items-center gap-2" data-id="element-96">
            <CreditCard className="w-4 h-4" data-id="element-97" /> Tarjetas · Transferencia · MP
          </div>
        </div>

        <div className="border-t border-slate-800 pt-10 text-slate-500 text-sm flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-98">
          <div className="font-bold text-slate-400" data-id="element-99">
            🤸 GIMNASIA ARTÍSTICA 360™
          </div>
          <div className="flex gap-4" data-id="element-100">
            <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-101">
              contacto@gimnasia360.com.ar
            </a>
            <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-102">
              @gimnasia360.ar
            </a>
            <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-103">
              www.gimnasia360.ar
            </a>
          </div>
          <div data-id="element-104">
            © GIMNASIA ARTÍSTICA 360™ 2025 Todos los derechos reservados.
          </div>
        </div>
      </div>
    </section>;
}